import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiBriefcase, FiUsers, FiMail, FiPhone, FiBookOpen, FiChevronRight } from 'react-icons/fi';
import api from '../../api/config';
import '../Basvuru/gmincele.css'; // Yolun doğruluğundan emin olun

const NevaYemekIncele = () => {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      setError(null);
      const response = await api.get('/api/basvurular/tum/neva-yemek');
      const data = response.data;

      if (!data || !data.ilanlar) {
        setJobs([]);
        return;
      }

      const jobsWithDetails = await Promise.all(data.ilanlar.map(async (job) => {
        const basvuranlarWithDetails = await Promise.all((job.basvuranlar || []).map(async (applicant) => {
          let cvData = null;
          let photoUrl = null;

          try {
            const cvResponse = await api.get(`/api/cv/${applicant.user_id}`);
            cvData = cvResponse.data?.[0] || null;
          } catch (cvErr) {
            console.error(cvErr);
          }

          try {
            const photoResponse = await api.get(`/api/photo/${applicant.user_id}`, { responseType: 'blob' });
            photoUrl = URL.createObjectURL(photoResponse.data);
          } catch {}

          return { ...applicant, cv: cvData, photoUrl };
        }));
        return { ...job, basvuranlar: basvuranlarWithDetails };
      }));

      setJobs(jobsWithDetails);
      
      if (jobsWithDetails.length > 0) {
        setSelectedJob(jobsWithDetails[0]);
      }
    } catch (error) {
      console.error(error);
      setError('Veriler yüklenirken bir sorun oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleApplicantClick = (applicant) => {
    navigate(`/basvuru-detay/${applicant.user_id}`, {
      state: { applicantData: applicant, kaynakTab: 'nevaYemekBasvuru' }
    });
  };

  if (loading) {
    return (
      <div className="corporate-loader-container">
        <div className="corp-loader"></div>
        <span>Yükleniyor...</span>
      </div>
    );
  }

  return (
    <div className="corp-dashboard">
      <div className="corp-header-bar">
        <div>
          <h1>Başvuru Yönetim Paneli</h1>
          <p className="subtitle">Neva Yemek Departmanı İK İzleme</p>
        </div>
      </div>

      <div className="corp-filter-section">
        <label htmlFor="job-select"><FiBriefcase /> Aktif İlan Seçimi:</label>
        <select 
          id="job-select"
          value={selectedJob?.ilan_detay.id || ''} 
          onChange={(e) => {
            const job = jobs.find(j => j.ilan_detay.id === parseInt(e.target.value));
            setSelectedJob(job);
          }}
        >
          {jobs.map(job => (
            <option key={job.ilan_detay.id} value={job.ilan_detay.id}>
              {job.ilan_detay.ilan_basligi} ({job.basvuranlar?.length || 0} Başvuru)
            </option>
          ))}
        </select>
      </div>

      <div className="corp-content-card">
        {selectedJob ? (
          <>
            <div className="panel-meta">
              <div className="meta-title">
                <h2>{selectedJob.ilan_detay.ilan_basligi}</h2>
                <span className="corp-badge bg-gray">{selectedJob.ilan_detay.sehir}</span>
              </div>
              <div className="meta-stats">
                <FiUsers /> <span><strong>{selectedJob.basvuranlar?.length || 0}</strong> Toplam Aday</span>
              </div>
            </div>

            {selectedJob.basvuranlar?.length === 0 ? (
              <div className="corp-empty-state">Bu ilana henüz herhangi bir başvuru yapılmamıştır.</div>
            ) : (
              <div className="corp-list">
                <div className="corp-list-header">
                  <div className="col-name">Aday Adı Soyadı</div>
                  <div className="col-contact">İletişim Bilgileri</div>
                  <div className="col-edu">Eğitim Durumu</div>
                  <div className="col-exp">Son Deneyim</div>
                  <div className="col-action"></div>
                </div>

                {selectedJob.basvuranlar.map((applicant) => {
                  const lastExp = applicant.is_deneyimleri?.[0];
                  return (
                    <div 
                      key={applicant.user_id} 
                      className="corp-list-item"
                      onClick={() => handleApplicantClick(applicant)}
                    >
                      <div className="col-name font-semibold">
                        {applicant.ad} {applicant.soyad}
                      </div>
                      
                      <div className="col-contact contact-details">
                        <span><FiMail /> {applicant.email}</span>
                        <span><FiPhone /> {applicant.cep_telefonu}</span>
                      </div>
                      
                      <div className="col-edu">
                        <span className="corp-tag-edu"><FiBookOpen /> {applicant.mezuniyet || '-'}</span>
                      </div>
                      
                      <div className="col-exp truncate-text">
                        {lastExp ? (
                          <span><strong>{lastExp.firma_adi}</strong> ({lastExp.pozisyon})</span>
                        ) : (
                          <span className="text-gray-light">Deneyim Yok</span>
                        )}
                      </div>
                      
                      <div className="col-action">
                        <button className="corp-view-btn">
                          İncele <FiChevronRight />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        ) : (
          <div className="corp-empty-state">Lütfen listelemek istediğiniz ilanı yukarıdan seçin.</div>
        )}
      </div>
    </div>
  );
};

export default NevaYemekIncele;